var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSkirt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.988 7.85v1.617a2.65 2.65 0 002.789 2.425h3.233l1.463 10.184a2.427 2.427 0 01-3.807 2.336 3.233 3.233 0 00-3.945.146 4.64 4.64 0 01-5.94 0 3.233 3.233 0 00-3.945-.146 2.426 2.426 0 01-3.807-2.344l1.43-10.176h3.234a2.651 2.651 0 002.829-2.425V7.85h6.466zm5.44 0l.348 2.425h-2.959c-.647 0-1.212-.38-1.212-.808V7.85h3.823zm-13.523 0v1.617c0 .428-.565.808-1.212.808H4.735l.347-2.425h3.823zM19.599 3a2.425 2.425 0 012.425 2.078l.17 1.156H5.317l.137-1.156A2.426 2.426 0 017.879 3z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgSkirt;